import {State} from "@model/State";
import {Rules} from "@model/Rules";

export class Controller {
    type;

    model;
    ihm;

    nextAnimationAvailableTime;

    eatTimeout;
    animationTimeout;
    isGameFinished;
    stoppedAnimation;

    history;

    constructor(type) {
        this.type = type;
        this.nextAnimationAvailableTime = 0;
        this.eatTimeout = null;
        this.animationTimeout = null;
        this.isGameFinished = false;
        this.stoppedAnimation = false;

        this.history = [];

    }

    stopAnimation() {
        this.stoppedAnimation = true;
        if (this.eatTimeout) {
            clearTimeout(this.eatTimeout);
            this.eatTimeout = null;
        }
        if (this.animationTimeout) {
            clearTimeout(this.animationTimeout);
            this.animationTimeout = null;
        }
    }

    executeWhenAnimationReady(action) {
        if (this.stoppedAnimation) return;
        const now = Date.now();
        if (now < this.nextAnimationAvailableTime) {
            const timeRemaining = this.nextAnimationAvailableTime - now;
            this.animationTimeout = setTimeout(() => this.executeWhenAnimationReady(action), timeRemaining);
        } else {
            action();
        }
    }

    isAnimationReady() {
        return Date.now() > this.nextAnimationAvailableTime
    }

    startApp(ihm, connection) {
        ihm.showLoading("Chargement en cours...");

        this.model = new State(ihm, connection);
        this.ihm = ihm;
        connection.setType(this);
        connection.sendAskInit(this.type);
    }

    waitApp(message) {
        this.ihm.showLoading(message);
    }

    showApp(matrix, player, gameId) {
        this.model.initGame(matrix, player, gameId);
        this.ihm.hideLoading();
    }

    endApp(reason) {
        this.isGameFinished = true;

        this.ihm.disableListeners();

        switch (reason) {
            case "disconnected":
                this.ihm.showPopUp(
                    "Déconnexion : L'autre joueur a quitté la partie.",
                    "Retourner au menu principal",
                    "rgba(255,0,0,0.7)",
                    () => {
                        this.ihm.reloadApp();
                    }
                );
                break;
            case "serverUnreachable":
                this.ihm.showPopUp(
                    "Impossible de se connecter au serveur après plusieurs tentatives, veuillez réessayez plus tard.",
                    "Recharger l'application",
                    "rgba(255,0,0,0.7)",
                    () => {
                        window.location.reload();
                    }
                );
                break;

            case "repeat":
                this.ihm.showPopUp(
                    "Partie bloquée. Match nul.",
                    "Retourner au menu",
                    "rgba(255,0,0,0.7)",
                    () => {
                        this.isGameFinished = false;
                        this.ihm.reloadApp();
                    }
                );
                break;
        }
    }

    controlMove(originX, originY, destX, destY, sendWebSocket = false) {
        if (this.isGameFinished) return;
        const checkerboard = this.model.checkerboard;
        if (Rules.isMovementDoable(checkerboard, originX, originY, destX, destY)) {
            this.nextAnimationAvailableTime = Math.max(this.nextAnimationAvailableTime, Date.now() + 850);

            const actualPlayer = this.model.checkerboard.getPawn(originX, originY).player;
            this.history.push({
                sourceX: originX,
                sourceY: originY,
                destX: destX,
                destY: destY,
                player: actualPlayer
            });

            if (Rules.checkRepeat(this.history)) {
                this.endApp('repeat');
            }

            this.model.movePawn(originX, originY, destX, destY, sendWebSocket);

            this.controlWin()
        }
    }

    controlEat(x, y) {
        if (this.isGameFinished) return;
        const checkerboard = this.model.checkerboard;
        if (Rules.canEat(checkerboard, x, y)) {
            this.nextAnimationAvailableTime = Math.max(this.nextAnimationAvailableTime, Date.now() + 2650);

            this.eatTimeout = setTimeout(() => {
                if (this.stoppedAnimation) return;
                this.model.eatPawn(x, y);
                this.controlWin();
            }, 1800);
        }
    }

    controlWin() {
        const playerWin = Rules.isWin(this.model.checkerboard);

        if (playerWin === 0) return;

        this.isGameFinished = true;

        this.ihm.disableListeners();

        if (playerWin === this.model.player) {

            this.ihm.showPopUp(
                "Vous avez gagné !",
                "Retourner au menu principal",
                "rgba(0, 255, 0, 0.7)",
                () => {
                    this.isGameFinished = false;
                    this.ihm.reloadApp();
                }
            );
        } else {
            this.ihm.showPopUp(
                "Vous avez perdu !",
                "Retourner au menu principal",
                "rgba(255, 0, 0, 0.7)",
                () => {
                    this.isGameFinished = false;
                    this.ihm.reloadApp();
                }
            );
        }
    }
}